import { userPoolClientId, userPoolId, region } from "./globalVariables";

export const AWS_CONFIG = {
    region: region,
    userPoolId: userPoolId,
    userPoolClientId: userPoolClientId,
    authenticationFlowType: "CUSTOM_AUTH",
}

